export default __webpack_public_path__ + "static/media/mapa-tematico.e55868af.svg";